module.exports = __webpack_public_path__ + "static/media/healthcare-software-benefits.37724a7c.webp";